module.exports = __webpack_public_path__ + "img/logo3.6c4d718d.png";